import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pageContext } from 'ctm-util-functions';

const _ProactiveHandoverTrigger = ({ dispatch }) => {
    const hasStarted = useRef(false);

    useEffect(() => {
        if (hasStarted.current) return;

        hasStarted.current = true;
        dispatch({
            type: 'PROCESS_PROACTIVE_HANDOVER',
            browserHistory: pageContext.getProps().browserHistory
        });
    }, [dispatch]);

    return null;
};

_ProactiveHandoverTrigger.propTypes = {
    dispatch: PropTypes.func.isRequired
};

const ProactiveHandoverTrigger = connect()(_ProactiveHandoverTrigger);

export { _ProactiveHandoverTrigger, ProactiveHandoverTrigger };
